import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

@Injectable()
export class SettingsService {
  public logado: boolean = false;
  public user: any = {};
  private app: any;
  private layout: any;
  public configUso: any = {};
  public tokenLTM: any = {};

  public urlretorno: string = "";

  public filtroMVs: any = [];
  public filtroRegionais: any = [];
  public filtroSubRegionais: any = [];
  public filtroUFs: any = [];
  public filtroDDDs: any = [];
  public filtroCoordenadores: any = [];
  public filtroSupervisores: any = [];
  public filtroCNs: any = [];
  public filtroKAs: any = [];
  public filtroRedesTipos: any = [];
  public filtroRedes: any = [];
  public filtroLojas: any = [];
  public filtroSegmentos: any = [];
  public filtroAgrupamentos: any = [];
  public filtroPlanos: any = [];
  public filtroFDV: any = [];
  public filtroOperacao: any = [];
  public filtroVendedores: any = [];
  public filtroDistribuidores: any = [];
  public filtroPerfis: any = [];
  public filtroCiclos: any = [];
  public filtroTags: any = [];

  constructor() {
    // User Settings
    // -----------------------------------
    /*
        this.user = {
            cpf: '',
            nome: '',
            celular: '',
            email: '',
            nascimento: '',
            sexo: '',
            imagem: '',
            idPerfil: '',
            perfil: '',
            idOwner: '',
            owner: '',
            dataOptin: '',
            obs: '',
            deviceId: '',
            resetSenha: '',
            criacao: '',
            atualizacao: '',
            incentivo: ''
        };
        */

    // App Settings
    // -----------------------------------
    this.app = {
      name: "Dashboard",
      description: "icons4u - We Love Marketing",
      year: new Date().getFullYear(),
    };

    // Layout Settings
    // -----------------------------------
    this.layout = {
      isFixed: true,
      isCollapsed: false,
      isBoxed: false,
      isRTL: false,
      horizontal: false,
      isFloat: false,
      asideHover: false,
      theme: null,
      asideScrollbar: false,
      isCollapsedText: false,
      useFullLayout: false,
      hiddenFooter: false,
      offsidebarOpen: false,
      asideToggled: false,
      viewAnimation: "ng-fadeInUp",
    };

    // environment
    // -----------------------------------
    this.configUso = environment;
  }

  getAppSetting(name) {
    return name ? this.app[name] : this.app;
  }

  getUserSetting(name) {
    return name ? this.user[name] : this.user;
  }

  getLayoutSetting(name) {
    return name ? this.layout[name] : this.layout;
  }

  setAppSetting(name, value) {
    if (typeof this.app[name] !== "undefined") {
      this.app[name] = value;
    }
  }

  setUserSetting(name, value) {
    if (typeof this.user[name] !== "undefined") {
      this.user[name] = value;
    }
  }

  setLayoutSetting(name, value) {
    if (typeof this.layout[name] !== "undefined") {
      return (this.layout[name] = value);
    }
  }

  toggleLayoutSetting(name) {
    return this.setLayoutSetting(name, !this.getLayoutSetting(name));
  }
}
